import styles from './beneficiaries.module.scss';
import clsx from 'clsx';
import BeneficiaryCard from './BeneficiaryCard';
import WidgetLoader from '../../../../atoms/widget-loader/WidgetLoader';
import { useQuery } from '@tanstack/react-query';
import { getBeneficiaries } from 'bff/hooks/reporting/BeneficiariesApi';
import WidgetError from '../../../../atoms/widget-error/WidgetError';
import { Suspense, useContext, useEffect } from 'react';
import { WidgetContext } from 'modules/dashboard/components/organisms/widget/Widget';
import { useSetWidgetQueryStatus } from 'modules/dashboard/types/widgets/widget.hooks';

const BeneficiariesWidget = () => {
  const context = useContext(WidgetContext);

  const {
    data: beneficiaries,
    isError,
    refetch,
    isFetching,
    isSuccess
  } = useQuery(getBeneficiaries({ clientId: 1 }));

  useEffect(() => {
    if (!context) return;
    context.setReloadHandler(() => () => {
      refetch();
    });
  }, []);

  useSetWidgetQueryStatus({ isFetching, isError, isSuccess, context });

  return (
    <Suspense fallback={<WidgetLoader />}>
      {isFetching ? (
        <div className={styles.container}>
          <WidgetLoader />
        </div>
      ) : isError ? (
        <WidgetError onRefresh={refetch} isRefreshing={isFetching} />
      ) : (
        beneficiaries?.map((beneficiary, index) => (
          <div
            data-testid={`beneficiaryCardContainer${index}`}
            key={index}
            className={clsx(
              styles.card,
              index === 0 ? '' : styles.cardPadding,
              index === beneficiaries.length - 1 ? '' : styles.cardBorder
            )}
          >
            <BeneficiaryCard
              data-testid={`beneficiary${index}`}
              firstName={beneficiary.firstName}
              lastName={beneficiary.lastName}
              investmentDetails={beneficiary.investmentBreakdown}
              index={index}
            />
          </div>
        ))
      )}
    </Suspense>
  );
};

export default BeneficiariesWidget;
